import {
  VpAudioMethods,
  VpBaseMethods,
  VpMovieClipMethods,
  VpDragonBoneMethods,
  VpParticleMethods,
  VpTweenMethods,
  VpVideoMethods,
  VpDrawLineMethods,
  VpEraseMethods,
} from '@ps/bridge/qc/vp/config'
import maskAction from './mask'
import carouselAction from './carousel'

const VpCategories = {
  animation: {
    single: 'Single Animation',
    all: 'All Animations',
  },
  movieClip: 'Sequence',
  dragonBone: 'DragonBone',
  particle: 'Particles',
  basic: {
    switchAndAction: 'Redirection and postback',
    node: 'Layer',
    timer: 'Timer',
    event: 'Event',
    bgm: 'BGM',
  },
  audio: 'Sound Effects',
  video: 'Video',
  drawLine: 'Match Line Component',
  freeDrawLine: 'Draw Lines Component',
  erase: 'Erase Component',
  carousel: 'Carousel Component',
  mask: 'Mask Component',
  other: 'Others',
}

export default {
  component: {
    switch: {
      'active-text': 'Enable',
      'inactive-text': 'Disable',
    },
  },
  action: {
    [VpTweenMethods.vpPlayTweenByUuid]: {
      label: 'Play a single animation',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'select an animation',
        },
      },
    },
    [VpTweenMethods.vpStopTweenByUuid]: {
      label: 'Pause a single animation',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'select an animation',
        },
      },
    },
    [VpTweenMethods.vpPlayTweenByUuidGoOn]: {
      label: 'Continue playing a single animation',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'select an animation',
        },
      },
    },
    [VpTweenMethods.vpResetTweenPropByUuid]: {
      label: 'Reset single animation',
      category: VpCategories.animation.single,
      paramFormConfig: {
        vpTweenUuid: {
          title: 'select an animation',
        },
      },
    },
    [VpTweenMethods.vpPlayTween]: {
      label: 'Play all animations from the beginning',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenGoOn]: {
      label: 'Resume all animations',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTween]: {
      label: 'Pause all animations',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpResetTweenProp]: {
      label: 'Reset all animations',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAll]: {
      label: 'Play all group animations',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpStopTweenChildrenAll]: {
      label: 'Pause all group animations',
      category: VpCategories.animation.all,
    },
    [VpTweenMethods.vpPlayTweenChildrenAllGoOn]: {
      label: 'Resume group animations',
      category: VpCategories.animation.all,
    },
    [VpMovieClipMethods.vpPlayMC]: {
      label: 'Play sequence frame',
      category: VpCategories.movieClip,
      paramFormConfig: {
        loop: {
          title: 'Loop',
        },
        hideWhenFinished: {
          title: 'Whether to hide after playing',
        },
        pingpong: {
          title: 'Play back and forth',
        },
        playTime: {
          title: 'Cycles',
        },
      },
    },
    [VpMovieClipMethods.vpStopMC]: {
      label: 'Pause Sequence',
      category: VpCategories.movieClip,
    },
    [VpDragonBoneMethods.vpPlaySKPlayer]: {
      label: 'Play DragonBone',
      category: VpCategories.dragonBone,
      paramFormConfig: {
        animationName: {
          title: 'Animation name',
        },
        loop: {
          title: 'Whether to cycle',
        },
        speed: {
          title: 'speed',
        },
      },
    },
    [VpDragonBoneMethods.vpStopSKPlayer]: {
      label: 'Pause DragonBone',
      category: VpCategories.dragonBone,
    },
    [VpParticleMethods.vpPlayParticle]: {
      label: 'Display particle effect',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpStopParticle]: {
      label: 'Pause particle effects',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpClearParticle]: {
      label: 'Turn off particle effect',
      category: VpCategories.particle,
    },
    [VpParticleMethods.vpParticleStartColor]: {
      label: 'Particle color',
      category: VpCategories.particle,
      paramFormConfig: {
        startColor: {
          title: 'Particle color',
        },
      },
    },
    [VpBaseMethods.vpSwitchScene]: {
      label: 'Redirect to the specified scene',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        jumpSceneId: {
          title: 'Redirect scene',
        },
      },
    },
    [VpBaseMethods.vpSwitchNextScene]: {
      label: 'Redirect to the next scene',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpInstall]: {
      label: 'Redirect to app store',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpGameEnd]: {
      label: 'Report the end of the playable ads',
      category: VpCategories.basic.switchAndAction,
    },
    [VpBaseMethods.vpSendAction]: {
      label: 'Set Tracking Event',
      category: VpCategories.basic.switchAndAction,
      paramFormConfig: {
        action_id: {
          title: 'Tracking ID',
        },
        action_name: {
          title: 'Tracking Name',
        },
      },
    },
    [VpBaseMethods.vpPosition]: {
      label: 'Set location',
      category: VpCategories.basic.node,
      paramFormConfig: {
        position: {
          title: 'Set location',
        },
      },
    },
    [VpBaseMethods.vpScaleXY]: {
      label: 'Set scale',
      category: VpCategories.basic.node,
      paramFormConfig: {
        scale: {
          title: 'Set scale',
        },
      },
    },
    [VpBaseMethods.vpRotate]: {
      label: 'Set rotation',
      category: VpCategories.basic.node,
      paramFormConfig: {
        rotation: {
          title: 'Rotation',
        },
      },
    },
    [VpBaseMethods.vpWidth]: {
      label: 'Set width',
      category: VpCategories.basic.node,
      paramFormConfig: {
        width: {
          title: 'Set width',
        },
      },
    },
    [VpBaseMethods.vpHeight]: {
      label: 'Set height',
      category: VpCategories.basic.node,
      paramFormConfig: {
        height: {
          title: 'Set height',
        },
      },
    },
    [VpBaseMethods.vpShowHide]: {
      label: 'Show/hide layer',
      category: VpCategories.basic.node,
      paramFormConfig: {
        isShow: {
          title: 'Show/hide',
          field: {
            options: [
              {
                label: 'Show',
              },
              {
                label: 'Hide',
              },
            ],
          },
        },
      },
    },
    [VpBaseMethods.vpAlpha]: {
      label: 'Set transparency',
      category: VpCategories.basic.node,
      paramFormConfig: {
        alpha: {
          title: 'Set transparency',
        },
      },
    },
    [VpBaseMethods.vpColor]: {
      label: 'Set color',
      category: VpCategories.basic.node,
      paramFormConfig: {
        color: {
          title: 'Set color',
        },
      },
    },
    [VpBaseMethods.vpWaitTime]: {
      label: 'Execution delay',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        ms: {
          title: 'Delay time',
        },
        timerId: {
          title: 'Timer name',
        },
        lastTimerId: {
          title: '',
        },
      },
    },
    [VpBaseMethods.vpClearTime]: {
      label: 'Cancel execution delay',
      category: VpCategories.basic.timer,
      paramFormConfig: {
        timerId: {
          title: 'Timer ID',
        },
      },
    },
    [VpBaseMethods.enabledEvent]: {
      label: 'Disable/Enable events',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'Event',
        },
        enabled: {
          title: 'Disable/Enable',
        },
      },
    },
    [VpBaseMethods.enabledEventActive]: {
      label: 'Enable events',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'Event',
        },
      },
    },
    [VpBaseMethods.enabledEventBan]: {
      label: 'Disable events',
      category: VpCategories.basic.event,
      paramFormConfig: {
        eventId: {
          title: 'Event',
        },
      },
    },
    [VpBaseMethods.vpPlayBgm]: {
      label: 'Play BGM',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpReplayBgm]: {
      label: 'Play background music from the beginning',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpResumeBgm]: {
      label: 'Continue playing background music',
      category: VpCategories.basic.bgm,
    },
    [VpBaseMethods.vpStopBgm]: {
      label: 'Pause the background music',
      category: VpCategories.basic.bgm,
    },
    [VpAudioMethods.vpPlaySound]: {
      label: 'Play sound',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: 'Whether to play from the beginning',
        },
        loop: {
          title: 'Loop',
        },
        loopNumber: {
          title: 'Cycles',
        },
      },
    },
    [VpAudioMethods.vpReplaySound]: {
      label: 'Play sound',
      category: VpCategories.audio,
      paramFormConfig: {
        loop: {
          title: 'Loop',
        },
        loopNumber: {
          title: 'Cycles',
        },
        isStopSound: {
          title: 'Stop playing the previously sound when triggered again.',
        },
      },
    },
    [VpAudioMethods.vpResumeSound]: {
      label: 'Continue playing sound',
      category: VpCategories.audio,
    },
    [VpAudioMethods.vpStopSound]: {
      label: 'Pause sound',
      category: VpCategories.audio,
      paramFormConfig: {
        isStop: {
          title: 'Whether to pause all sound effects of the current scene',
        },
      },
    },
    [VpVideoMethods.vpPlayVideo]: {
      label: 'Play video',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: 'Cycles',
        },
        loop: {
          title: 'Loop',
        },
        playEndFrame: {
          title: 'Keep tail frame',
        },
      },
    },
    [VpVideoMethods.vpReplayVideo]: {
      label: 'Play video from the beginning',
      category: VpCategories.video,
      paramFormConfig: {
        loopNumber: {
          title: 'Cycles',
        },
        loop: {
          title: 'Loop',
        },
        playEndFrame: {
          title: 'Keep tail frame',
        },
      },
    },
    [VpVideoMethods.vpResumeVideo]: {
      label: 'Continue playing video',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpStopVideo]: {
      label: 'Pause the video',
      category: VpCategories.video,
    },
    [VpVideoMethods.vpPauseVideo]: {
      label: 'Pause the video',
      category: VpCategories.video,
    },
    [VpDrawLineMethods.vpEraseLine]: {
      label: 'Erase Lines',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'Erase Objects',
        },
      },
    },
    [VpDrawLineMethods.vpModifyLineStyle]: {
      label: 'Edit Line Style',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: 'Start and End Regions',
        },
        lineColor: {
          title: 'Line Color',
        },
        lineStyle: {
          title: 'Line Thickness',
        },
      },
    },
    [VpDrawLineMethods.vpEnablePair]: {
      label: 'Enable/Disable Pairing',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'Pairing Relationship',
        },
        enableBan: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpModifyPairLineStyle]: {
      label: 'Edit the Style of Paired Lines',
      category: VpCategories.drawLine,
      paramFormConfig: {
        pair: {
          title: 'Pairing Relationship',
        },
        lineColor: {
          title: 'Line Color',
        },
        lineStyle: {
          title: 'Line Thickness',
        },
      },
    },
    [VpDrawLineMethods.vpEnableBanArea]: {
      label: 'Enable/Disable Start and End Regions',
      category: VpCategories.drawLine,
      paramFormConfig: {
        area: {
          title: 'Start and End Regions',
        },
        enableBan: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEraseLine]: {
      label: 'Erase Lines',
      category: VpCategories.freeDrawLine,
    },
    [VpDrawLineMethods.vpFreeModifyLineStyle]: {
      label: 'Edit Line Style',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        lineColor: {
          title: 'Line Color',
        },
        lineStyle: {
          title: 'Line Thickness',
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnable]: {
      label: 'Enable/Disable Draw Lines Component',
      category: VpCategories.freeDrawLine,
      paramFormConfig: {
        enableBan: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpDrawLineMethods.vpFreeEnableRigidBody]: {
      label: 'Create a rigid body after drawing the lines.',
      category: VpCategories.freeDrawLine,
    },
    [VpEraseMethods.vpEnableEraseComponent]: {
      label: 'Enable/Disable Erase Component',
      category: VpCategories.erase,
      paramFormConfig: {
        isEnable: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEraseTrace]: {
      label: 'Clear Erase Marks',
      category: VpCategories.erase,
      paramFormConfig: {},
    },
    [VpEraseMethods.vpShowGroup]: {
      label: 'Show/Hide Groups',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
        isShow: {
          title: 'Show/Hide',
          field: {
            options: [
              {
                label: 'Show',
              },
              {
                label: 'Hide',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpEnableEraseableGroup]: {
      label: 'Enable/Disable Erasable Groups',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
        isEnable: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpEraseMethods.vpPlayAllMovieClipForGroup]: {
      label: 'Show and Play All Frames of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
      },
    },
    [VpEraseMethods.vpPauseAllMovieClipForGroup]: {
      label: 'Pause All Frames of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenForGroup]: {
      label: 'Play Single Animation of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
        vpTweenUuid: {
          title: 'Select Animation',
        },
      },
    },
    [VpEraseMethods.vpPauseTweenForGroup]: {
      label: 'Pause Single Animation of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
        vpTweenUuid: {
          title: 'Select Animation',
        },
      },
    },
    [VpEraseMethods.vpPlayTweenGoOnForGroup]: {
      label: 'Resume Single Animation of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
        vpTweenUuid: {
          title: 'Select Animation',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenForGroup]: {
      label: 'Play All Animations of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
      },
    },
    [VpEraseMethods.vpPauseAllTweenForGroup]: {
      label: 'Pause All Animations of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
      },
    },
    [VpEraseMethods.vpPlayAllTweenGoOnForGroup]: {
      label: 'Resume All Animations of Group',
      category: VpCategories.erase,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
        },
      },
    },
    [VpEraseMethods.vpReplaceHandImage]: {
      label: 'Replace the image following the fingerr',
      category: VpCategories.erase,
      paramFormConfig: {
        handImage: {
          title: 'Image following the finger',
        },
      },
    },
    [VpBaseMethods.vpShakeScreen]: {
      label: 'Screen jitter',
      category: VpCategories.other,
      paramFormConfig: {
        duration: {
          title: 'Duration',
        },
        fequence: {
          title: 'Jitter frequency',
        },
        xy: {
          title: 'Jitter maximum distance',
        },
      },
    },
    [VpBaseMethods.vpCompute]: {
      label: 'Assign the value',
      category: VpCategories.other,
      paramFormConfig: {
        target: {
          title: 'Global variables',
        },
        method: {
          title: 'Operation method',
        },
        value: {
          title: 'Operand',
        },
      },
    },
    [VpBaseMethods.vpRetry]: {
      label: 'Retry Playable',
      category: VpCategories.other,
    },
    ...maskAction.maskAction,
    ...carouselAction.carouselAction,
  },
  VpCategories,
}
